module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated fadeIn",
    class: {
      'is-active': _vm.$route.path.indexOf('/comments') > -1
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('proposal_comments_modal.comments')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(!_vm.comments || _vm.comments.length <= 0) ? _c('div', {
    staticClass: "no-comments"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('recent_comments.no_recent_comments')))])]) : _vm._e(), _vm._v(" "), (_vm.comments !== false && _vm.comments.length > 0) ? _c('ul', _vm._l((_vm.comments), function(comment) {
    return _c('comment', {
      key: comment.id,
      attrs: {
        "comment": comment,
        "show-avatar": true,
        "comment-type": "full"
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    ref: "commentBox",
    attrs: {
      "contenteditable": "",
      "disabled": _vm.disableNewComments,
      "placeholder": _vm.$t('proposal_comments_modal.comment_text_placeholder')
    },
    on: {
      "focus": function($event) {
        _vm.showCommentActionButtons = true
      },
      "blur": function($event) {
        _vm.showCommentActionButtons = false
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.stopPropagation();
        _vm.submitComment($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCommentActionButtons),
      expression: "showCommentActionButtons"
    }],
    staticClass: "button is-primary is-large is-pulled-left push-right",
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v(_vm._s(_vm.$t('proposal_comments_modal.send_message')))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCommentActionButtons),
      expression: "showCommentActionButtons"
    }],
    staticClass: "button is-primary is-large is-outlined is-pulled-left",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('proposal_comments_modal.cancel')))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f261de98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/document-comments-modal.vue
// module id = 553
// module chunks = 0